import React, { useCallback, useEffect } from "react";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import PrivateComponentLoadingPage from "../LoadingPage/PrivateComponentLoadingPage";
import PaymentsAppLayout from "../../Components/Molecules/PaymentsAppLayout";
import { useAdminStore } from "../../Store/Admin";
import { useParams } from "react-router-dom";

const AdminTeamTransactionsListPage = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { team_id } = useParams();
  const { isLoading, getOneTeam, teamDetails } = useAdminStore();
  const onLoad = useCallback(async () => {
    team_id && getOneTeam(getAccessTokenSilently, team_id);
  }, [team_id, getAccessTokenSilently, getOneTeam]);
  useEffect(() => {
    onLoad();
  }, [onLoad]);
  return (
    <PaymentsAppLayout>
      {isLoading ? (
        <div className="h-6 w-60 animate-pulse bg-gray-300 rounded" />
      ) : (
        teamDetails && (
          <div className="text-xl font-semibold">Transactions for {teamDetails?.name}</div>
        )
      )}
    </PaymentsAppLayout>
  );
};

export default withAuthenticationRequired(AdminTeamTransactionsListPage, {
  onRedirecting: () => <PrivateComponentLoadingPage />
});
